
const cf7ThankYouMessage = () => {
    const theForm = document.querySelector('.wpcf7-form');
    const theMessage = document.querySelector('.ume-career-thank-you');
    if(theForm !== null && theMessage !== null){
        const thankYouButton = theMessage.querySelector('.ume-career-thank-you--button');
        const theModal = theForm.closest('.modal');

        const trigger = theForm.querySelector('.wpcf7-submit');

        trigger.addEventListener('click', ev =>{
            trigger.classList.add('disabled');
        })
        document.addEventListener('wpcf7invalid', ev =>{
            trigger.classList.remove('disabled');
        })
        document.addEventListener('wpcf7mailfailed ', ev =>{
            trigger.classList.remove('disabled');
        })
        document.addEventListener('wpcf7mailsent', ev =>{
            theForm.style.visibility = 'hidden';
            theForm.setAttribute('aria-hidden', true);
            theMessage.style.visibility = 'visible';
            theMessage.setAttribute('aria-hidden', false);
            thankYouButton.classList.remove('disabled');
            trigger.classList.remove('disabled');
            function resetFormModal(){
                theForm.style.visibility = 'visible';
                theForm.setAttribute('aria-hidden', false);
                theForm.classList.add('init');
                theForm.setAttribute('data-status', 'init');
                theMessage.style.visibility = 'hidden';
                theMessage.setAttribute('aria-hidden', true);
                thankYouButton.classList.add('disabled');


            }
            thankYouButton.addEventListener('click', ev =>{
                ev.preventDefault();
                ev.stopPropagation();
                resetFormModal();



            }, true);
            if(theModal !== null){
                jQuery(theModal).on('hidden.bs.modal', function (e){
                    resetFormModal();
                })
            }



        });
    }
}
export default cf7ThankYouMessage;